// Uma resposta por linha vira lista; linhas vazias somem.
export const emLinhas = texto =>
  (texto || '')
    .split('\n')
    .map(linha => linha.trim())
    .filter(Boolean);

export const CAMPOS_EM_LISTA = [
  'descobrir_antes',
  'sempre_fazer',
  'nunca',
  'chamar_pessoa',
];

// SPEC-07: o submenu do Capitao (assistentes, cenarios...) so aparece com o flag captain_integration e
// sem o modulo novo, para nunca haver dois "Agente de IA" no menu.
export const mostrarMenuDoCapitao = ({ capitao, agenteIa }) =>
  !!capitao && !agenteIa;

// SPEC-11: com o módulo desligado, o item do menu leva à oferta em vez do módulo — só quando a oferta
// está ativa, quem olha é administrador e a conta não é vendida por uma agência (quem vende lá é ela).
export const mostrarOfertaNoMenu = ({ agenteIaEnabled, ofertaAtiva, admin }) =>
  !agenteIaEnabled && !!ofertaAtiva && !!admin;

// Faixa do teto de gasto: normal, aviso a partir de 80%, pausado ao passar de 100%.
export const faixaDoTeto = teto => {
  if (!teto) return 'NORMAL';
  if (teto.pausado) return 'PAUSADO';
  return teto.percentual >= 80 ? 'AVISO' : 'NORMAL';
};

// Passos de quem esta comecando: Montar -> Testar -> Ligar numa caixa.
export const passosDoInicio = status => {
  const montado = !!status?.vinculo?.montado;
  const ligado = (status?.caixas_ligadas || 0) > 0;
  return [
    {
      chave: 'CHAVE',
      feito: !!status?.persona?.com_chave,
      rota: 'agente_ia_chaves',
    },
    { chave: 'MONTAR', feito: montado, rota: 'agente_ia_montar' },
    { chave: 'TESTAR', feito: montado && ligado, rota: 'agente_ia_testar' },
    { chave: 'LIGAR', feito: ligado, rota: 'agente_ia_caixas' },
  ];
};
